<template>
  <v-card>

    <v-toolbar dark color="blue darken-3">
      <v-btn icon dark @click="close">
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>{{restaurant.nm}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark flat @click="updateRestaurant">
          업데이트
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-form ref="form" v-model="valid" lazy-validation>
        <v-container grid-list-md>
          <v-list>
            <v-subheader>비밀번호 설정</v-subheader>
            <v-list-tile>
              <v-text-field prepend-icon="lock"  label="입장 제한 비밀번호(없어도됨)" v-model="restaurant.pw" type="current-password"></v-text-field>
            </v-list-tile>
            <v-subheader>홈페이지</v-subheader>
            <v-list-tile>
              <v-text-field prepend-icon="http"  label="홈페이지 URL" v-model="restaurant.homepage" ></v-text-field>
            </v-list-tile>            
            <v-subheader>식당 가격</v-subheader>
            <v-list-tile>
              <v-text-field prepend-icon="monetization_on"  v-model="restaurant.price"  suffix="원"></v-text-field>
            </v-list-tile>            
            <br>
            <v-subheader>사용 여부</v-subheader>
            <v-list-tile>
              <v-flex xs12>
              <v-switch prepend-icon="search"
                label='사람들이 식당을 검색할수 있도록 합니다'
                v-model="restaurantActive"
              ></v-switch>
              </v-flex>
            </v-list-tile>
          </v-list>
          <br>
          <v-subheader>기본 템플릿 설정</v-subheader>
            <div id="food-list-categoryies-setting">
              <food-category v-for="meal in restaurant.template" :key="meal.category" :meal="meal">
              </food-category>
            </div>
        </v-container>
    </v-form>
  </v-card>
</template>

<script>
import { ApiService } from "@/services/GuneApiService.js";
import FoodCategory from "@/components/FoodCategory.vue";

export default {
  name: "RestaurantSettingModal",
  components: {
    FoodCategory
  },
  data: () => ({
    valid: true,
    restaurantName: "",
    restaurantNameRules: [v => !!v || "식당명 필요합니다"],
    restaurantPassword: "",
    restaurantActive: true,
    restaurantPrice: 0,
    homepage: ""
  }),
  props: {
    settingDialog: Boolean,
    restaurant: Object
  },
  methods: {
    close() {
      this.$refs.form.reset();
      this.$emit("update:settingDialog", false);
    },
    updateRestaurant() {
      ApiService()
        .put("/gune/" + this.restaurant.gid , {
            active: this.restaurantActive,
            pw: this.restaurant.pw,
            template : this.restaurant.template,
            price : this.restaurant.price,
            homepage: this.restaurant.homepage
        })
        .then(res => {
          // context.commit("setRestaurants", res.data);
          alert("업데이트 완료" + res.data);
          this.$store.dispatch("getRestaurants");
          this.$emit("update:settingDialog", false);
        })
        .catch(function(err) {
          alert(
            "식당 변경에 실패 했습니다 계속 문제가 발생하면 오픈채팅방으로 문의 주세요~" +
              err
          );
        });
    }
  }
};
</script>

<style>
#food-list-categoryies-setting {
  display: flex;
  flex-direction: column;
  width: 100%;
}
</style>
